import { useContext, useEffect, useState } from "react";
import "./restaurant-menu-add.styles.scss";
import { MenuContext } from "../../../../contexts/menu.context";
const initiateItem = {
  itemName: "",
  price: "",
  description: "",
};
const RMAdd = ({ addFunction }) => {
  const [item, setItem] = useState(initiateItem);
  const [saveMenuClass, setSaveMenuClass] = useState("");
  const { itemName, price, description } = item;
  const [menuChangeClass, setMenuChangeClass] = useState();
  const { menuChange, updateMenu } = useContext(MenuContext);
  const addItemFucntion = (event) => {
    event.preventDefault();
    addFunction(item);
    setItem(initiateItem);
  };
  useEffect(() => {
    setMenuChangeClass(menuChange);
  }, [menuChange]);
  const handleChange = (event) => {
    const { value, name } = event.target;
    setItem({ ...item, [name]: value });
  };

  return (
    <div className="rm-add-container">
      <span className="rm-add-title">ADD NEW MENU ITEM</span>
      <form className="rm-add-form" onSubmit={addItemFucntion}>
        <input
          type="text"
          className="rm-add-input"
          placeholder="Name"
          name="itemName"
          value={itemName}
          onChange={handleChange}
        />
        <input
          type="text"
          className="rm-add-input"
          placeholder="Price"
          name="price"
          value={price}
          onChange={handleChange}
        />
        <textarea
          placeholder="Description(optional)"
          className="rm-add-textarea"
          name="description"
          value={description}
          onChange={handleChange}
        ></textarea>
        <div className="rm-add-buttons">
          <button className="rm-add-button">Submit</button>
          {menuChangeClass ? (
            <button className="rm-save-menu-show" onClick={updateMenu}>
              Save Menu
            </button>
          ) : (
            <button className="rm-save-menu">Save Menu</button>
          )}
        </div>
      </form>
    </div>
  );
};
export default RMAdd;
